angular.module('omfm').service('Accounts', InboxAccountsService);

InboxAccountsService.$inject = ['$resource', 'ServerInterceptor'];

function InboxAccountsService($resource, ServerInterceptor) {
	return $resource('/accounts', {"id": "@id"}, {
		'list': {
			'url': "/admin/accounts/list",
			'method': 'get',
			'interceptor': ServerInterceptor,
			'isArray': true
		}
	})
}